import { Controller } from "@hotwired/stimulus"
import { matchesPersonaValue } from "../utils/persona_filter_matching"

export default class extends Controller {
  static targets = ["generateButton", "outdatedBadge", "requestedRecords"]
  static values = { hasEstimate: Boolean, estimateStale: Boolean }

  // -- Public actions --

  applyPreset(event) {
    const presetName = event.currentTarget.dataset.presetName
    const presetFilters = JSON.parse(event.currentTarget.dataset.presetFilters || '{}')

    const nameInput = this.element.querySelector('input[name="audience_name"]')
    if (nameInput) nameInput.value = presetName

    this._uncheckAllFilters()

    for (const [filterKey, personaValue] of Object.entries(presetFilters)) {
      if (!personaValue) continue
      const checkboxes = this.element.querySelectorAll(`input[name="filters[${filterKey}][]"]`)
      checkboxes.forEach(cb => {
        if (matchesPersonaValue(cb.value, personaValue, filterKey)) {
          cb.checked = true
        }
      })
    }

    this.filtersChanged()
  }

  applyRecordPreset(event) {
    if (!this.hasRequestedRecordsTarget) return

    this.requestedRecordsTarget.value = event.currentTarget.dataset.recordCount
    this.requestedRecordsTarget.dispatchEvent(new Event("input", { bubbles: true }))
  }

  recordCountChanged() {
    this._syncRecordPresetHighlights()
  }

  filtersChanged() {
    this.estimateStaleValue = true
    if (this.hasOutdatedBadgeTarget) this.outdatedBadgeTarget.classList.remove("hidden")
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = true
    this._syncPresetHighlights()
  }

  estimateReceived() {
    this.hasEstimateValue = true
    this.estimateStaleValue = false
    if (this.hasOutdatedBadgeTarget) this.outdatedBadgeTarget.classList.add("hidden")
    if (this.hasGenerateButtonTarget) this.generateButtonTarget.disabled = false
  }

  generate() {
    const form = this.element.closest("form") || this.element.querySelector("form")
    if (!form) return
    if (this.hasRequestedRecordsTarget && !this.requestedRecordsTarget.value) {
      this.requestedRecordsTarget.reportValidity()
      return
    }

    const actionInput = form.querySelector("input[name='_action']") || document.createElement("input")
    actionInput.type = "hidden"
    actionInput.name = "_action"
    actionInput.value = "generate"
    if (!actionInput.parentNode) form.appendChild(actionInput)
    form.action = form.dataset.generateUrl
    form.requestSubmit()
  }

  // -- Preset highlight sync --

  _syncPresetHighlights() {
    const presetButtons = this.element.querySelectorAll('[data-action="click->listgen-drawer#applyPreset"]')

    presetButtons.forEach(btn => {
      const presetFilters = JSON.parse(btn.dataset.presetFilters || '{}')
      const matches = this._filtersMatchPreset(presetFilters)

      btn.classList.toggle('astral-filter-preset--active', matches)
    })

    this._syncRecordPresetHighlights()
  }

  _syncRecordPresetHighlights() {
    if (!this.hasRequestedRecordsTarget) return

    const requested = this.requestedRecordsTarget.value
    const presetButtons = this.element.querySelectorAll('[data-action="click->listgen-drawer#applyRecordPreset"]')

    presetButtons.forEach(btn => {
      const matches = btn.dataset.recordCount === requested
      btn.classList.toggle('astral-record-preset--active', matches)
    })
  }

  _filtersMatchPreset(presetFilters) {
    const checkboxes = this.element.querySelectorAll('input[type="checkbox"][name^="filters"]')

    for (const cb of checkboxes) {
      const filterKey = cb.name.match(/filters\[(\w+)\]/)?.[1]
      if (!filterKey) continue

      const personaValue = presetFilters[filterKey]
      const shouldBeChecked = personaValue ? matchesPersonaValue(cb.value, personaValue, filterKey) : false

      if (cb.checked !== shouldBeChecked) return false
    }

    return true
  }

  // -- Helpers --

  _uncheckAllFilters() {
    this.element.querySelectorAll('input[type="checkbox"][name^="filters"]').forEach(cb => {
      cb.checked = false
    })
  }
}
